module.exports = __webpack_public_path__ + "static/image/together/m/visual@3x.jpg?760c1ece";